import { render, staticRenderFns } from "./PolicyAgreement.vue?vue&type=template&id=f0d20f06&scoped=true"
import script from "./PolicyAgreement.vue?vue&type=script&lang=js"
export * from "./PolicyAgreement.vue?vue&type=script&lang=js"
import style0 from "./PolicyAgreement.vue?vue&type=style&index=0&id=f0d20f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d20f06",
  null
  
)

export default component.exports